import { createSlice } from '@reduxjs/toolkit'
import { getExternalChannels, putExternalChannel } from '../lib/api'

export const externalChannelSlice = createSlice({
  name: 'externalChannel',
  initialState: {
    channels: [],
    loaded: false,
    loading: false,
    error: null
  },
  reducers: {
    loading: state => {
      state.loading = true
    },
    load: (state, { payload }) => {
      state.channels = payload
      state.loaded = true
      state.loading = false
    },
    add: (state, { payload }) => {
      state.channels.push(payload)
    },
    remove: (state, { payload }) => {
      const copy = state.channels.filter(t => t.id !== payload)
      state.channels = copy
    },
    update: (state, { payload }) => {
      const copy = state.channels.map(t => {
        if (t.id === payload.id) {
          return payload
        }
        return t
      })
      state.channels = copy
    },
    failed: (state, { payload }) => {
      state.error = payload
      state.loading = false
      state.loaded = true
    }
  }
})

export default externalChannelSlice.reducer

export const {
  loading,
  load,
  add,
  remove,
  update,
  failed
} = externalChannelSlice.actions

// Asynchronous thunk action
export function fetchExternalChannels () {
  return async dispatch => {
    dispatch(loading())
    try {
      const externals = await getExternalChannels()
      dispatch(load(externals))
    } catch (error) {
      dispatch(failed(error))
    }
  }
}

// Asynchronous thunk action
export function addExternalChannels (name, external) {
  return async dispatch => {
    try {
      //const newType = await postUserType({ name, external })
      //dispatch(add(newType))
    } catch (err) {
      dispatch(failed(err))
    }
  }
}

// Asynchronous thunk action
export function deleteExternalChannels (id) {
  return async dispatch => {
    try {
      //await deleteUserType(id)
      //dispatch(remove(id))
    } catch (err) {
      dispatch(failed(err))
    }
  }
}

// Asynchronous thunk action
export function updateExternalChannels (id, data) {
  return async dispatch => {
    const updated = await putExternalChannel(id, data)
    dispatch(update(updated))
  }
}

export const selectExternalChannel = state => state.externalChannel
